/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who4_TitleInputs */

const en_dr_who4_title = /** @type {(inputs: Dr_Who4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design-thinking coaches`)
};

const id_dr_who4_title = /** @type {(inputs: Dr_Who4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatih design thinking`)
};

/**
* | output |
* | --- |
* | "Design-thinking coaches" |
*
* @param {Dr_Who4_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who4_title = /** @type {((inputs?: Dr_Who4_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who4_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who4_title(inputs)
	return en_dr_who4_title(inputs)
});